<template>
  <tr :class="{ disabled: entity.timestamp_deleted}">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="'ppvrCheckbox'+entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="'ppvrCheckbox'+entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název'" class="first_data"><strong>{{ entity.name }}</strong></td>
    <td :data-th="'Vytvořilo zařízení'">
      <entity-link :id="entity.id_device" type="device">{{ entity.device_name }}</entity-link>
    </td>
    <td :data-th="'Uživatelské profily'"><span v-for="(profile, index) in entity.profiles" :key="index"><span v-if="index !== 0">, </span>
      <entity-link :id="profile.id" type="subscriberProfile">{{ profile.name }}</entity-link>
    </span></td>
    <td :data-th="'Počet dní nahrávání zpět za CatchUp'">{{ entity.days_back }} </td>
    <td :data-th="'Minimální čas začátku nahrávání'" v-html="$_date_formatFull(entity.minimal_timestamp)"></td>
    <td :data-th="'Kanál nahrávání'">
      <entity-link :id="entity.id_channel" type="channel">{{ entity.channel_name }}</entity-link>
    </td>
    <td :data-th="'Datum vytvoření'" v-html="$_date_formatFull(entity.timestamp_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a v-if="isDeletable" class="btn btn_action btn_delete" @click.stop="onDeletePeriodicPvr" :title="$gettext('Smazat')">{{
            $gettext('Smazat')
          }}</a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../../common/EntityLink.vue";

export default {
  name: "PeriodicPvrRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
    enabled: Boolean,
    isDeletable: Boolean,
  },
  methods: {
    onDeletePeriodicPvr() {
      this.$emit('deletePeriodicPvr', this.entity.id);
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/periodicPvrs/PeriodicPvrRow.vue